import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import IpadAd from '../../../components/ipadAd';

class DFNewsSider extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { dfNewsSiderAd, ipadAd6 },
        } = this.props;

        return (
            <div className={styles.sider_box}>
                {dfNewsSiderAd ? (
                    <Ad content={dfNewsSiderAd} styleName={styles.sider} />
                ) : (
                    <div className={styles.ipad_sider}>
                        <Chip id="40108" type="static" title="广告7" groupName="数码佛教要闻区左侧栏" content={ipadAd6}>
                            <IpadAd />
                        </Chip>
                    </div>
                )}
            </div>
        );
    }
}

export default errorBoundary(DFNewsSider);
